import { render, staticRenderFns } from "./ListaPrenotazioni.vue?vue&type=template&id=82b9edea&scoped=true&"
import script from "./ListaPrenotazioni.vue?vue&type=script&lang=js&"
export * from "./ListaPrenotazioni.vue?vue&type=script&lang=js&"
import style0 from "./ListaPrenotazioni.vue?vue&type=style&index=0&id=82b9edea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b9edea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VLazy,VProgressCircular,VRow,VSwitch,VTextField})
